<a *ngIf="url" [href]="url" target="_blank" [attr.aria-label]="('visit' | translate) + ' ' + label" data-automation-id="nlbSiteLink">
  <img src="../../../../../assets/Arrow-Up-Right-From-Square.svg" alt="" class="clickable-icon">
</a>